// extracted by mini-css-extract-plugin
export default {"roundButton":"round-button-close_roundButton__vkoQA","crossLeft":"round-button-close_crossLeft__6s5tM","crossRight":"round-button-close_crossRight__VQ+C-"};